import SubmissionEditionPanel from './SubmissionEditionPanel';

export default SubmissionEditionPanel;
